/**
 * `?from=me|manage|inbox` on a shared request detail page (docs/71 §7):
 * which side opened it. Manage and Inbox links set it; without it the page
 * is Me for the requester and Manage for anyone else (lib/surfaces.ts).
 * An unknown value is dropped, never an error.
 */

import { z } from "zod";

export const fromSearchSchema = z.object({
  from: z.enum(["me", "manage", "inbox"]).optional().catch(undefined),
});

export type FromSearch = z.infer<typeof fromSearchSchema>;
